import React from 'react';
import { Menu } from 'antd';
import { Tooltip } from 'antd';
const { SubMenu } = Menu;
const CutsomSubMenu = (props) => {
  const { children, key, icon, title, collapsed, ...rest } = props;

  return collapsed ? (
    <Tooltip placement='right' title={title}>
      <SubMenu key={key} icon={icon} title={title} {...rest}>
        {children}
      </SubMenu>
    </Tooltip>
  ) : (
    <SubMenu key={key} icon={icon} title={title} {...rest}>
      {children}
    </SubMenu>
  );
};
export default CutsomSubMenu;
